import api from '../../../App/socket';

export const createOrder = (id, kind, date_from, date_to) => (
    api.send({
        api: 'db',
        model: 'Lead_transport',
        action: 'Create',
        options: {
            create: {
                ref_lead: id,
                transport_date_data: { kind, date_from, date_to },
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/create_order_request.js